/**
 * Effets visuels de la Soif sur la fiche de son propre personnage.
 * Préférence par appareil (localStorage) : un simple confort d'affichage.
 */
import {useEffect, useState} from 'react';

const STORAGE_KEY = 'vtm.hungerEffects';
const CHANGE_EVENT = 'vtm-hunger-effects';

/** 0 : rien (Soif 0-2) · 1 : voile léger (3) · 2 : voile marqué, gouttes qui battent (4) · 3 : voile qui bat (5) */
export const hungerTier = (hunger) => Math.max(0, Math.min(3, (hunger || 0) - 2));

/**
 * Évolution des taches d'Humanité entre deux états de la fiche :
 * 'added' (nouvelle tache), 'cleansed' (taches effacées, Humanité intacte),
 * 'degenerated' (Humanité perdue : les taches disparaissent avec elle), ou null.
 */
export const stainChange = (previous, next) => {
  if (!previous) return null;
  if (next.humanity < previous.humanity) return 'degenerated';
  if (next.stains > previous.stains) return 'added';
  if (next.stains < previous.stains) return 'cleansed';
  return null;
};

const readEnabled = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch (e) {
    return true;
  }
};

export const setHungerEffectsEnabled = (enabled) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, enabled ? 'on' : 'off');
  } catch (e) {
    // Stockage indisponible (navigation privée…) : le réglage vaut pour la session
  }
  window.dispatchEvent(new CustomEvent(CHANGE_EVENT, {detail: enabled}));
};

/** @returns {Boolean} effets activés, synchronisé entre la barre de navigation et la fiche */
export const useHungerEffectsEnabled = () => {
  const [enabled, setEnabled] = useState(readEnabled);
  useEffect(() => {
    const onChange = event => setEnabled(event.detail);
    window.addEventListener(CHANGE_EVENT, onChange);
    return () => window.removeEventListener(CHANGE_EVENT, onChange);
  }, []);
  return enabled;
};
